import { EventManager } from '@creditas/event-manager';
import { EventListen, EventResponse } from './events.types';

const Listen = ({
  application = '',
  event = '',
  type = '',
  callback,
}: EventListen): void =>
  EventManager.listen(application, event, type).subscribe((e: EventResponse) =>
    callback(e),
  );

export default Listen;
